import React from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../constants/routes";
import styled from "styled-components";
import {
    Button,
    ChevronStartIcon,
    Flex,
    Text,
} from "@fluentui/react-northstar";

export const DetailOffboardingHeader = ({ activeTab, AgencyId }) => {
    const navigate = useNavigate();
    const _backpage = () => {
        navigate(
            ROUTES.offboarding.home +
                "?tab=" +
                AgencyId +
                "&subtab=" +
                activeTab
        );
        // navigate(-1);
    };
    return (
        <Header space="between">
            <Flex vAlign="center" gap="gap.small">
                <Button
                    onClick={_backpage}
                    iconOnly
                    icon={<ChevronStartIcon />}
                />
                <Title content={"Détails du collaborateur"} />
            </Flex>
            <Button onClick={_backpage} text content={"Retour"} />
        </Header>
    );
};

const Header = styled(Flex)`
    margin-top: 24px;
    padding-inline: 16px;
`;
const Title = styled(Text)`
    color: #242424;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
`;
